/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cc from 'classcat';
import Logo from '../../../resources/images/white-logo.svg';
import SmallLogo from '../../../resources/images/small-logo.svg';
import { MeetingMenuItems } from './MeetingMenuItems';
import { useSelect } from '../../../../utils/selector.utils';
import { MeetingLiveItems } from './MeetingLiveItems';
import { meetingsSimplePageSelectors } from '../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { settingsSelectors } from '../../../../app/resource/settings/settings.selectors';

export const SideBar = () => {
  const { pathname } = useLocation();

  const activePath = useMemo(
    () => [
      pathname === '/',
      pathname.match(/\/home/),
      pathname.match(/\/agency-tools(\/.*)?/),
      // pathname.match(/\/accounts/),
      pathname.match(/\/meetings/),
      pathname.match(/\/directory/),
      // pathname.match(/\/time-tracking/),
      pathname.match(/\/settings\/*/),
      // pathname.match(/\/passwords/),
      // pathname.match(/\/team-meeting-dashboard\/?$/),
      // pathname.match(/\/team-meeting-kpi\/?$/),
      // pathname.match(/\/live-meeting\/?$/),
    ],
    [pathname],
  );

  const teamIds = useSelect(meetingsSimplePageSelectors.selectTeams);

  // const loggedUserisAdmin = useSelector(authSelectors.selectUserIsAdmin);

  // const reducedMeetings = useSelect(meetingsPageSelectors.selectReducedMeetings);
  // const teamIds = reducedMeetings.meeting;
  // const accountIds = reducedMeetings['account'];
  // const meetingIds = [...teamIds, ...accountIds];
  // console.log(meetingIds);

  const settings = useSelect(settingsSelectors.selectCurrentSettings);

  const dashboardLogo = settings?.dashboardLogo && settings.dashboardLogo !== null ? settings.dashboardLogo : Logo;
  const hasDashboardLogo = dashboardLogo !== Logo;

  return (
    <aside className={hasDashboardLogo ? 'has-dashboard-logo' : ''}>
      <Link to="/home" className="logo">
        <img src={dashboardLogo} style={{ maxWidth: 190 }} alt="" className="img-fluid" />
      </Link>
      <Link to="/home" className="logo-small" style={{ opacity: hasDashboardLogo ? 0 : 1 }}>
        <img src={SmallLogo} alt="" className="img-fluid" />
      </Link>
      <menu className="pt-1 h100">
        <div className="menu-container h100 flex flex-column">
          <ul className="main-menu">
            <li className={cc({ active: activePath[0] || activePath[1] })}>
              <Link to="/home">
                <i className="icon-home"></i> <span>DASHBOARD</span>
              </Link>
            </li>
            <li className={cc({ active: activePath[2] })}>
              <Link to="/agency-tools">
                <i className="icon-briefcase"></i> <span>AGENCY TOOLS</span>
              </Link>
            </li>
            {/* <li className={cc({ active: activePath[1] })}>
              <Link to="/agency-tools">
                <i className="icon-briefcase"></i> <span>AGENCY TOOLS</span>
              </Link>
            </li> */}
            {/* <li className={cc({ active: activePath[2] })}>
              <Link to="/accounts">
                <i className="icon-info"></i> <span>ACCOUNTS</span>
              </Link>
            </li> */}
            <li className={cc({ active: activePath[3] })}>
              <Link to="/meetings">
                <i className="icon-users"></i> <span>MEETINGS</span>
              </Link>
            </li>
            <li className={cc({ active: activePath[4] })}>
              <Link to="/directory">
                <i className="icon-user-full"></i> <span>DIRECTORY</span>
              </Link>
            </li>
            {/*
            <li className={cc({ active: activePath[5] })}>
              <Link to="/time-tracking">
                <i className="icon-clock"></i> <span>TIME TRACKING</span>
              </Link>
            </li>*/}
            <li className={cc({ active: activePath[5] })}>
              {/* @todo: enable /settings when other section than profile is available */}
              <Link to={'/settings/profile'}>
                {/* <Link to={loggedUserisAdmin ? '/settings' : '/settings/profile'}> */}
                <i className="icon-settings"></i> <span>SETTINGS</span>
              </Link>
            </li>
          </ul>

          <MeetingLiveItems />

          {/* <MeetingManuItems type={'account'} meetingIds={accountIds} /> */}
          {/* <hr /> */}
          <MeetingMenuItems type={'meeting'} meetingIds={teamIds} />
          <div className="powered-by flex pb-2 mr-auto mt-auto text-left">
            <a
              href="https://www.account-able.io/"
              className="f-1 flex flex-column white"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Powered by</span> <img src={Logo} alt="" className="img-fluid" style={{ height: 15 }} />
            </a>
          </div>
        </div>
      </menu>
    </aside>
  );
};
